import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
// import Wrp from '../../../hoc/Wrp/Wrp';
import {isSet} from '../../../../Utils/CommonFunctions';
// import ToolTipWrapper from '../../../../hoc/Wrp/ToolTipWrapper';
class ActiveInActive extends Component {
  
    componentDidMount(){
      // console.log(this.props);
    }
    render () {
      const {colData,id,header} = this.props;
      // console.log('colData',colData);
      const eventsHandler = {
        onClick:() => (colData.clickHandler) ?
                colData.clickHandler(colData,colData.attributes):
                      'javascript(void)'
      }
      let headerAtt={}
      try{
        headerAtt = {
          ...header.attributes,
          class:header.attributes.class+' '+(colData.className)?colData.className:''
        }
      }catch(e){

      }
      let displayData = <></>;
      if(isSet(colData.value,'false').toString()==='true'){
        displayData = 
          <span title="Selected">
            <i className="fas fa-check	text-success fa-lg"></i>
          </span>
      }else if(isSet(colData.value,'false').toString()==='false'){
        displayData = 
        <span title="Not Selected">
          <i className="fas fa-times	text-danger fa-lg"></i>
        </span>
      }
        return(
            <td key={"column"+id} {...header.attributes}>
               {displayData}
            </td>
        );
    }
}

export default ActiveInActive;